// src/lib/api-integrations.ts
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export interface PricesApiStatus {
  configured: boolean;
  added_at: number | null;
  added_by: string | null;
  last_test_at: number | null;
  last_test_ok: boolean | null;
}

export function usePricesApiStatus(workspaceId: string | null) {
  return useQuery<PricesApiStatus>({
    queryKey: ['integrations', 'pricesapi', workspaceId],
    queryFn: () => api.get<PricesApiStatus>('/integrations/pricesapi'),
    enabled: !!workspaceId,
  });
}

export function useSavePricesApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => api.put<{ ok: boolean }>('/integrations/pricesapi', { key }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations', 'pricesapi'] }),
  });
}

export function useTestPricesApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.post<{ ok: boolean; detail: string | null }>('/integrations/pricesapi/test', {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations', 'pricesapi'] }),
  });
}

export function useDeletePricesApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.del<{ ok: boolean }>('/integrations/pricesapi'),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['integrations', 'pricesapi'] }),
  });
}
